<template>
  <div v-studio-click-outside="closePopup" class="tw-relative tw-flex tw-items-center">
    <StudioAvatar :name="email" clickable @click="toggleOpen" />
    <transition name="slide">
      <div
        v-if="isOpen"
        id="menu-list"
        data-testid="studio-account-menu"
        class="tw-absolute tw-right-0 tw-top-9 tw-z-50 tw-w-48 tw-overflow-hidden tw-rounded-lg tw-border tw-bg-white tw-text-xs tw-shadow-lg dark:tw-bg-black"
      >
        <button
          v-for="menuItem in menuItems"
          :id="menuItem.id"
          :key="menuItem.title"
          :data-testid="menuItem.id"
          class="tw-flex tw-w-full tw-items-center tw-gap-2 tw-px-3 tw-py-3 tw-text-sm tw-transition-colors hover:tw-bg-deep-orange-600 hover:tw-text-white focus:tw-bg-deep-orange-50 focus:tw-text-deep-orange-600 focus:tw-ring-0"
          @click="
            () => {
              menuItem.action();
              closePopup();
            }
          "
        >
          <span class="tw-font-medium">
            {{ menuItem.title }}
          </span>
        </button>
        <div class="tw-flex tw-flex-col tw-px-3 tw-py-3 tw-text-xs tw-font-medium">
          <div class="tw-mb-1 tw-break-all tw-font-semibold tw-leading-none tw-text-deep-orange-600">
            {{ email }}
          </div>
          <div class="tw-break-all tw-leading-none">{{ organizationName }}</div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import StudioAvatar from './StudioAvatar.vue';

export interface AccountMenuItem {
  title: string;
  id: string;
  action: () => void;
}

export default defineComponent({
  name: 'StudioAccountMenu',
  components: {
    StudioAvatar
  },
  props: {
    menuItems: {
      type: Array as () => AccountMenuItem[],
      required: true
    },
    organizationName: {
      type: String,
      required: true
    },
    email: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    toggleOpen() {
      this.isOpen = !this.isOpen;
    },
    closePopup() {
      this.isOpen = false;
    }
  }
});
</script>

<style scoped>
.slide-enter-active,
.slide-leave-active {
  transition: all 0.15s ease;
}

.slide-enter-from,
.slide-leave-to {
  opacity: 0;
  transform: translateY(10%);
}
</style>
